import { Box, Typography } from "@material-ui/core";
import {
  BannerSeverity,
  Icon,
  IconName,
  NotificationBanner,
  useDeviceTypes,
} from "halifax";
import clsx from "clsx";
import React from "react";
import { ConnectionRetrySuccessBannerConnectorProps } from "./container";
import {
  CONNECTION_RETRY_SUCCESS_SUBTITLE,
  CONNECTION_RETRY_SUCCESS_TITLE,
} from "./textConstants";
import "./styles.scss";

export type IConnectionRetrySuccessBannerProps =
  ConnectionRetrySuccessBannerConnectorProps;

export const ConnectionRetrySuccessBanner = ({
  showConnectionRetryBanner,
  dismissConnectionRetryBanner,
}: IConnectionRetrySuccessBannerProps) => {
  const { matchesMobile } = useDeviceTypes();

  if (!showConnectionRetryBanner) return null;

  return (
    <NotificationBanner
      className={clsx("connection-retry-success-banner", {
        mobile: matchesMobile,
      })}
      // halifax styles error/warning/notice/improvement/neutral_info — the
      // default INFO severity renders unstyled.
      severity={BannerSeverity.NOTICE}
      icon={<Icon name={IconName.InfoCircleFill} />}
      content={
        <Box className="connection-retry-success-banner-content">
          <Typography
            variant="body2"
            className="connection-retry-success-banner-title"
          >
            {CONNECTION_RETRY_SUCCESS_TITLE}
          </Typography>
          <Typography variant="body2">
            {CONNECTION_RETRY_SUCCESS_SUBTITLE}
          </Typography>
        </Box>
      }
      onDismiss={dismissConnectionRetryBanner}
    />
  );
};
